/**
 * utils/arrays.ts
 *
 * Small array helpers.
 */

/** Same length and the same items in order (compared with ===). */
export function sameItems<T>(a: readonly T[], b: readonly T[]): boolean {
  return a.length === b.length && a.every((item, index) => item === b[index]);
}
